export default {
  achievements_load_all: '/api/achievements/load_all',
  achievements_save: '/api/achievements/save',
  achievements_update: '/api/achievements/update',
  achievements_remove: '/api/achievements/remove',
  achievements_earned: '/api/achievements/earned',
};
